import { render, staticRenderFns } from "./ConfigurationPersonIdRouterView.vue?vue&type=template&id=31986749&scoped=true&"
import script from "./ConfigurationPersonIdRouterView.vue?vue&type=script&lang=js&"
export * from "./ConfigurationPersonIdRouterView.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationPersonIdRouterView.vue?vue&type=style&index=0&id=31986749&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31986749",
  null
  
)

export default component.exports